import React from 'react'
import profileImg from '../../../assets/images/profileImg.svg'
import { hasMembershipType } from '../../utils'
import { getMemberStatusLabel } from './utils'
import { useMembershipJourneyContext } from './MembershipJourneyContext'
import {
  Container,
  ProfileImage,
  ContentWrapper,
  LeftSection,
  ProfileInfo,
  NameRow,
  Name,
  Badge,
  Details,
  SectionName,
  MemberId,
  EditLink,
  EditText
} from './Styles/ProfileBrief.styles'

const ProfileBrief = ({ me, onEditClick, authReady }) => {
  const { pgmProgress } = useMembershipJourneyContext()
  const displayName = me.displayName || `${me.firstName} ${me.lastName}`
  const statusLabel = getMemberStatusLabel(pgmProgress)
  const sectionName = me.primarySection?.name
  const pgaId = me.pgaId

  if (!authReady || !me) return null

  return (
    <Container>
      <ProfileImage 
        src={me.profilePhoto || me.photo || profileImg} 
        alt={displayName}
      />
      <ContentWrapper>
        <LeftSection>
          <ProfileInfo>
            <NameRow>
              <Name>{displayName}</Name>
              {statusLabel && <Badge>{statusLabel}</Badge>}
            </NameRow>
            <Details>
              {sectionName && <SectionName>{sectionName}</SectionName>}
              {hasMembershipType(me) && pgaId && (
                <MemberId>PGA ID: #{pgaId}</MemberId>
              )}
            </Details>
          </ProfileInfo>
        </LeftSection>
        {hasMembershipType(me) && (
          <EditLink onClick={onEditClick || (() => window.location.href = '/profile/edit')}>
            <EditText>Edit My Profile</EditText>
            <i className='fa fa-angle-right' style={{ color: '#0082CE' }} />
          </EditLink>
        )}
      </ContentWrapper>
    </Container>
  )
}

export default ProfileBrief
